import { exportDataGrid } from 'devextreme/exporter/exceljs/export_data_grid';
import { htmlToText } from 'html-to-text';
import i18next from 'i18next';
import saveAs from 'file-saver';
import ExcelJS from 'exceljs';

export default (e, specialColumns = []) => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(i18next.t('DataGrid'));

    exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        customizeCell: ({ gridCell, excelCell }) => {
            if (gridCell.rowType === 'data') {
                if (specialColumns.find(c => gridCell.column.dataField === c)) {
                    excelCell.value = htmlToText(gridCell.value, { wordwrap: null });
                }
                if (gridCell.column.dataField === 'creatAt') {
                    excelCell.value = new Date(gridCell.value).toDateString();
                }
                if (gridCell.column.dataField === 'isActive') {
                    excelCell.value = gridCell.value ? i18next.t('YES') : i18next.t('NO');
                }
            }
            if (gridCell.rowType === 'group') {
                excelCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'BEDFE6' } };
            }
            if (gridCell.rowType === 'totalFooter' && excelCell.value) {
                excelCell.font.italic = true;
            }
        }
    }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
        });
    });
    e.cancel = true;
}